module.exports = __webpack_public_path__ + "img/IntelliseqFlow-light.4de9ded6.svg";